import React, { useCallback, useEffect, useState } from "react";
import { CgDanger, CgCheckO, CgBlock } from "react-icons/cg";
import { FaEdit, FaBook, FaWhatsapp } from "react-icons/fa";
import { IoAddCircleOutline, IoNotifications } from "react-icons/io5";
import { PageListRef, PageList } from "../../../components/PageList";
import { ITable } from "../../../components/TableList";
import { useApi } from "../../../hooks/api";
import { useGlobal } from "../../../hooks/global";
import { IFilters, IStaysReservationProps, IActions, IPlanProps } from "../../../interfaces";
import { correctDate, setUpConsultation, correctDateDashboard } from "../../../services/generalServices";
import { info, secondary } from "../../../theme";
import { getFilterFields } from "../../../utils/filterFields";
import { get_corrrect_names, checkInStatusOptions, reservationStatusOptions } from "../../../utils/options";
import { ModalPlans } from "../../../components/Modals/ModalPlans";

export const checkInStatusMapper: { [key: string]: { text: string; color: string, icon: React.ReactElement<any> } } = {
  pending: { text: "Pendente", color: '#FAAD14', icon: <CgDanger size={19} style={{ marginRight: 3 }} /> },
  done: { text: "Realizado", color: '#52C41A', icon: <CgCheckO size={16} style={{ marginRight: 3 }} /> },
  late: { text: "Em atraso", color: '#FF6B6B', icon: <CgBlock size={19} style={{ marginRight: 3 }} /> },
  not_realized: { text: "Não realizado", color: '#FF6B6B', icon: <CgBlock size={16} style={{ marginRight: 3 }} /> },
}

const initialFilters: IFilters[] = [
  getFilterFields("order_by"),
  getFilterFields("reservation_status"),
  getFilterFields("check_in_status"),
  getFilterFields("check_out_status"),
  getFilterFields("check_in"),
  getFilterFields("check_out"),
  getFilterFields("created_at"),
];

const initialTable: ITable = {
  data: [],
  columns: [
    {
      attr: "name",
      name: "Nome",
      style: { textAlign: "center" },
      styleContent: { fontSize: 16, fontWeight: 600, textAlign: "center" },
    },
    {
      attr: "minimum_quantity_accommodation",
      name: "Qtd mínima de acomodações",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14, textAlign: "center" },
    },
    {
      attr: "value",
      name: "Valor",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14, textAlign: "center" },
    },
    {
      attr: "value_extra_accommodation",
      name: "Valor acomodação extra",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14, textAlign: "center" },
    },
  ],
};

export const propertyInExtension = (address: any) => {
  if (!address) return "-";
  return `${address?.street}, ${address?.region}, Nº ${address?.streetNumber}, ${address?.city} - ${address?.stateCode}`;
};

export const PlansRoot: React.FC = () => {
  const { user, api } = useApi();
  const { theme, paginationLimit, notify } = useGlobal();

  const [planIdSelected, setplanIdSelected] = useState<string | null>(null)

  const [loading, setLoading] = useState(false);
  const [atualPage, setAtualPage] = useState(1);
  const [filters, setFilters] = useState<any>({});
  const [openModal, setOpenModal] = useState(false);
  const [numOfReservations, setNumOfReservations] = useState(0);
  const [updatedAt, setUpdatedAt] = useState(new Date());
  const [loadingReservations, setLoadingReservations] = useState(true);
  const [searchString, setSearchString] = useState<string>("");
  const [numberOfPages, setNumberOfPages] = useState<number>(1);
  const [reservationSelected, setReservationSelected] = useState<IPlanProps | null>(null);
  const [table, setTable] = useState<ITable>(initialTable);
  const page_ref = React.useRef<PageListRef>(null);

  const selectPlann = useCallback(
    (plan: IPlanProps) => {
      setReservationSelected({ ...plan });
      setOpenModal(true);
    },
    []
  );

  const searchPlans = useCallback(
    async (page, _filters = null) => {
      setAtualPage(page);
      setLoadingReservations(true);

      try {
        const filters_obj = _filters ? _filters : { ...filters, search: searchString };

        let string = setUpConsultation(filters_obj);
        let url = `/plan/?page=${page}&limit=${paginationLimit}&${string}`;

        const result = await api.get(url);
        const new_plan = result.data.data as IPlanProps[];

        setTable((atual) => {
          const new_table = { ...atual };

          new_table.data = [];
          new_plan.forEach((plan) => {

            new_table.data.push({
              id: plan.id,

              name: plan.name,
              minimum_quantity_accommodation: plan.minimum_quantity_accommodation,
              value: plan.value,
              value_extra_accommodation: plan.value_extra_accommodation,
              this: plan,
            });
          });

          return { ...new_table };
        });
        setNumOfReservations(result.data.count);
        setNumberOfPages(Math.ceil(result.data.count / paginationLimit));
        setUpdatedAt(new Date());
      } catch (err) {
        notify("Erro na busca pelos planos!", "error");
      }
      setLoadingReservations(false);
    },
    [user, filters, searchString, planIdSelected]
  );

  const changeFreeTrialPlan = useCallback(
    async (item: IPlanProps) => {
      const new_is_test_free = !item?.is_test_free;
      
      setTable((atual) => {
        const new_table = { ...atual };
        const pos = new_table.data.findIndex((d) => d?.this.id === item.id);
        if (pos !== -1) new_table.data[pos].this.is_test_free = new_is_test_free;
        return { ...new_table };
      });


      try {
        await api.put(`/plan/${item.id}`, { is_test_free: new_is_test_free });
        notify("Status teste grátis do plano alterado com sucesso", "success");
      } catch (err) {
        notify("Erro ao alterar status do teste grátis do plano", "error");
        setTable((atual) => {
          const new_table = { ...atual };
          const pos = new_table.data.findIndex((d) => d?.this.id === item.id);
          if (pos !== -1) new_table.data[pos].this.is_test_free = new_is_test_free;
          return { ...new_table };
        });
      }
    },
    []
  );

  const changeStatusPlan = useCallback(
    async (busId: string, old_status: boolean) => {
      const new_active = !old_status;

      setTable((atual) => {
        const new_table = { ...atual };
        const pos = new_table.data.findIndex((d) => d?.this.id === busId);
        if (pos !== -1) new_table.data[pos].this.active = new_active;
        return { ...new_table };
      });

      try {
        await api.put(`/plan/${busId}`, { active: new_active });
        notify("Status do plano atualizado com sucesso", "success");
      } catch (err) {
        notify("Erro ao alterar status do plano", "error");
        setTable((atual) => {
          const new_table = { ...atual };
          const pos = new_table.data.findIndex((d) => d?.this.id === busId);
          if (pos !== -1) new_table.data[pos].this.active = old_status;
          return { ...new_table };
        });
      }
    },
    []
  );

  const openModalNewReservation = useCallback(() => {
    setReservationSelected(null);
    setOpenModal(true);
  }, []);

  const handleAction = (action_id: string) => {
    if (action_id === "new_item") openModalNewReservation();
  };

  const actionsInitial: IActions[] = [
    {
      main_option: { text: "Novo Plano", id: "new_item" },
      className: "new_item",
      icon: <IoAddCircleOutline size={20} className="new_item" />,
      options: [],
      type: "solid",
      permissions: ["ROOT"],
    },
  ];

  const listAction = [
    {
      title: "Editar",
      onClick: (plan: IPlanProps) => selectPlann(plan),
      icon: <FaEdit color={secondary[theme]} size={20} />,
      disabled: () => false,
    },
  ];

  const onSaveReservation = useCallback(() => {
    setOpenModal(false);
    searchPlans(1);
  }, [user, filters, searchString]);

  useEffect(() => {
    const query = window.location.search.split("?").pop()
    const queries = query ? query.split("&") : [""]
    let status: any = queries.find((item: string) => item.split("=")[0] === "status")
    status = status ? status.split("=")[1] : null
    if (status) {
      setFilters({ check_in_status: status, reservation_status: 'booked' })

      page_ref.current?.setFilters((prev) => {
        const checkInStatusFilterIndex = prev.findIndex((filter) => filter.key === "check_in_status" as any)
        const reservationStatusFilterIndex = prev.findIndex((filter) => filter.key === "reservation_status" as any)

        if (checkInStatusFilterIndex !== -1) {
          const mapper = get_corrrect_names(checkInStatusOptions);

          prev[checkInStatusFilterIndex] = { ...prev[checkInStatusFilterIndex], value: { label: mapper[status], value: status } }
        }

        if (reservationStatusFilterIndex !== -1) {
          const mapper = get_corrrect_names(reservationStatusOptions);
          prev[reservationStatusFilterIndex] = { ...prev[reservationStatusFilterIndex], value: { label: mapper['booked'], value: 'booked' } }
        }

        return prev
      })

      searchPlans(1, { check_in_status: status, reservation_status: 'booked' })
    }
    else searchPlans(1)
  }, [planIdSelected]);

  return (
    <PageList
      updatedAt={updatedAt}
      loading={loadingReservations}
      setLoading={setLoadingReservations}
      numberOfItems={numOfReservations}
      onClickOption={handleAction}
      textHeader="Planos"
      textItems="planos encontradas"
      text_loading={"Buscando Planos"}
      text_empty={"Nenhum plano encontrada"}
      theme={theme}
      actions={actionsInitial}
      initialFilters={initialFilters}
      onChangeFilters={setFilters}
      table={table}
      pages={numberOfPages}
      page={atualPage}
      search={searchPlans}
      onChangeSearch={setSearchString}
      listActions={listAction}
      ref={page_ref}
      have_status={true}
      statusText="Disponível"
      status_action={changeStatusPlan}
      switch_action={changeFreeTrialPlan}
      have_switch={true}
      switch_checked={'is_test_free'}
      switchText="Teste Grátis"
    >
      {openModal && (
        <ModalPlans
          onCancel={() => setOpenModal(false)}
          onSave={onSaveReservation}
          openModal={openModal}
          backgroundVisible={false}
          defaultId={reservationSelected?.id}
        />
      )}

    </PageList>
  );
};
